import Button from "@material-tailwind/react/Button";
import H6 from "@material-tailwind/react/Heading6";
import Label from "@material-tailwind/react/Label";
import Small from "@material-tailwind/react/Small";
import React from 'react';
import { useHistory } from "react-router";

const ProjectCard = (props) => {
    const { id, name, image, description, live, client, server, technologies } = props.data;
    const history = useHistory();
    return (
        <div className="w-10/12 mx-auto my-12 flex lg:flex-row md:flex-row flex-col">
            <div className="lg:w-2/4 md:w-2/4 w-full">
                <img className='w-10/12 mx-auto' src={image} alt="" />
            </div>

            <div className="lg:w-2/4 md:w-2/4 w-full flex flex-col justify-start">
                <div className="w-full ">
                    <H6 color="gray">{name}</H6>
                    <div className="lg:block md:block hidden ">
                        <Small color="gray">
                            {description}
                        </Small>
                        <div className="flex flex-wrap justify-center mt-8">
                            {
                                technologies.map((tech, index) => <Label className="m-1" key={index} color="lightBlue">{tech}</Label>)
                            }
                        </div>
                    </div>


                </div>

                <div className="w-full mt-8">
                    <div className="w-full flex flex justify-center">
                        <a href={live} target="_blank" rel="noopener noreferrer" className="m-1"> <Button
                            color="lightBlue"
                            buttonType="outline"
                            size="sm"
                            rounded={false}
                            block={false}
                            iconOnly={false}
                            ripple="dark"

                        >
                            Live
                        </Button></a>
                        <a href={client} target="_blank" rel="noopener noreferrer" className="m-1">  <Button
                            color="lightBlue"
                            buttonType="outline"
                            size="sm"
                            rounded={false}
                            block={false}
                            iconOnly={false}
                            ripple="dark"
                        >
                            Client
                        </Button></a>
                        <a href={server} target="_blank" rel="noopener noreferrer" className="m-1"> <Button
                            color="lightBlue"
                            buttonType="outline"
                            size="sm"
                            rounded={false}
                            block={false}
                            iconOnly={false}
                            ripple="dark"
                        >
                            Server
                        </Button></a>
                    </div>
                    <Button
                        color="lightBlue"
                        buttonType="filled"
                        size="refular"
                        rounded={false}
                        block={false}
                        iconOnly={false}
                        ripple="dark"
                        className="mx-auto mt-4"
                        onClick={() => {
                            history.push(`/project/detail/${id}`);
                        }}
                    >
                        Details
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ProjectCard;